import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ThumbDown } from '../../../../../icons/thumb-down';
import { ThumbsUp } from '../../../../../icons/thumbs-up';
import { UsersGroup } from '../../../../../icons/users-group';
import STRING_KEYS from '../../../../../language/keys';
import { style } from './style';
import { EngineStatusCardItem } from './EngineStatusCardItem';

type EngineStatusCardsProps = {
  resultsAmount: string,
  declineAmount: string,
  relevanceAmount: string,
}

export const EngineStatusCards = ({
  resultsAmount,
  declineAmount,
  relevanceAmount,
}:EngineStatusCardsProps):JSX.Element => {
  const { t: translate } = useTranslation();

  const stats = [
    {
      title: translate(STRING_KEYS.RESULTS),
      amount: resultsAmount,
      color: 'action.active',
      icon: (
        <UsersGroup
          viewBox={ style.Icon.viewBox }
          sx={ style.Icon.sx }
        />
      ),
    },
    {
      title: translate(STRING_KEYS.DECLINE_RATE),
      amount: `${declineAmount}%`,
      color: 'error.main',
      icon: (
        <ThumbDown
          viewBox={ style.IconThumbDown.viewBox }
          sx={ style.Icon.sx }
        />
      ),
    },
    {
      title: translate(STRING_KEYS.RELEVANCE_RATE),
      color: 'success.main',
      amount: `${relevanceAmount}%`,
      icon: (
        <ThumbsUp
          viewBox={ style.Icon.viewBox }
          sx={ style.Icon.sx }
        />
      ),
    },
  ];

  return (
    <Box sx={ style.Box.sx }>
      {stats.map(({
        title, amount, icon, color,
      }) => {
        return (
          <EngineStatusCardItem
            key={ title }
            amount={ amount }
            subTitle={ title }
            icon={ icon }
            color={ color }
          />
        );
      })}
    </Box>
  );
};
